// PageContainer component

import React, { Component } from 'react'
import { IntlProvider } from 'react-intl'

import app from '../../../app.jsx'
import Acl from '../../../lib/acl.jsx'
import intlUtil from '../../../lib/intlutil.jsx'
import IntlFormat from '../../common/intlformat/intlformat.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'
import ConnectionUtil from '../../../lib/connectionutil.jsx'

// Pages
import PageLoginV2 from '../../page/page_loginv2/page_loginv2.jsx'
import PageSignup from '../../page/page_signup/page_signup.jsx'
import PageResetv2 from '../../page/page_resetv2/page_resetv2.jsx'
import PageDashboard from '../../page/page_dashboard/page_dashboard.jsx'
import PageUserProfile from '../../page/page_userprofile/page_userprofile.jsx'
import PageSignupTeamV2 from '../../page/page_signupteamv2/page_signupteamv2.jsx'

import PageReport from '../../../report/page/page_report/page_report.jsx'
import PageReportView from '../../../report/page/page_reportview/page_reportview.jsx'

import PageProject from '../../../project/page/page_project_v3/page_project.jsx'
import PageProjectViewTeam from '../../../project/page/page_projectview_team/page_projectview_team.jsx'
import PageProjectViewBudget from '../../../project/page/page_projectview_budget/page_projectview_budget.jsx'
import PageProjectViewBudgetV2 from '../../../theme/page/page_projectview_budget/page_projectview_budget.jsx'
import PageProjectViewHour from '../../../project/page/page_projectview_hour/page_projectview_hour.jsx'
import PageProjectViewOverview from '../../../project/page/page_projectview_overview/page_projectview_overview.jsx'
import PageProjectViewPlanner from '../../../project/page/page_projectview_planner/page_projectview_planner.jsx'
import PageProjectViewTask from '../../../project/page/page_projectview_task/page_projectview_task.jsx'

import PageUser from '../../../setting/page/page_user/page_user.jsx'
import PageCompanyProfile from '../../../setting/page/page_companyprofile/page_companyprofile.jsx'
import PageProjectSetting from '../../../setting/page/page_project_setting/page_project_setting.jsx'
import PageDemoSetting from '../../../setting/page/page_demo_setting/page_demo_setting.jsx'
import PageIntegration from '../../../setting/page/page_integration/page_integration.jsx'
import PagePayment from '../../../setting/page/page_payment/page_payment.jsx'
import PageSubscription from '../../../setting/page/page_subscription/page_subscription.jsx'
import PagePaymentFailed from '../../../setting/page/page_paymentfailed/page_paymentfailed.jsx'
import PagePdfTemplate from '../../../setting/page/page_pdftemplate/page_pdftemplate.jsx'
import PageMailTemplate from '../../../setting/page/page_mailtemplate/page_mailtemplate.jsx'

import PageTime from '../../../time/page/page_time/page_time.jsx'

import PageEstimate from '../../../estimate/page/page_estimate/page_estimate.jsx'
import PageEstimateView from '../../../estimate/page/page_estimate_view/page_estimate_view.jsx'

import PageExpense from '../../../expense/page/page_expense/page_expense.jsx'
import PagePurchaseOrder from '../../../expense/page/page_purchaseorder/page_purchaseorder.jsx'
import PagePurchaseOrderView from '../../../expense/page/page_purchaseorder_view/page_purchaseorder_view.jsx'

import PageInvoice from '../../../invoice/page/page_invoice/page_invoice.jsx'
import PageInvoiceView from '../../../invoice/page/page_invoice_view/page_invoice_view.jsx'
import PageInvoiceTemplate from '../../../invoice/page/page_invoice_template/page_invoice_template.jsx'
import PageInvoiceTemplateView from '../../../invoice/page/page_invoicetemplate_view/page_invoicetemplate_view.jsx'

import PageSchedule from '../../page/page_schedule/page_schedule.jsx'
import PageAbsent from '../../page/page_absent/page_absent.jsx'
import PageSkills from '../../page/page_skills/page_skills.jsx'
import PagePersonalSetting from '../../page/page_personal_setting/page_personal_setting.jsx'

import PageTaskMain from '../../../theme/page/page_main_task/page_main_task.jsx'
import PageTaskStandardUser from '../../../task/page/page_task_standarduser/page_task_standarduser.jsx'
import PageMobile from '../../../time/page/page_mobile/page_mobile.jsx'
import Page404 from '../../page/page_404/page_404.jsx'
import PageBlock from '../../page/page_block/page_block.jsx'
import PageSignupConfirm from '../../page/page_signupconfirm/page_signupconfirm.jsx'
import PageEmailConfimation from '../../page/page_emailconfimation/page_emailconfimation.jsx'
import PageExpired from '../../page/page_expired/page_expired.jsx'
import PageTaxRate from '../../../setting/page/page_taxrate/page_taxrate.jsx'
import PageDemoImport from '../page_demoimport/page_demoimport.jsx'
import PagePlanner from '../../../theme/page/page_planner/page_planner.jsx'
import PagePlannerTask from '../../../theme/page/page_task/page_task.jsx'
import PageTeamSelect from '../../page/page_teamselect/page_teamselect.jsx'
import PageChat from '../page_chat/index.jsx'

class PageContainer extends Component {
  static get propTypes () {
    return {}
  }

  static get defaultProps () {
    return {}
  }

  constructor (props) {
    super(props)

    this.state = {
      bIntlReady: false,
      dataDate: null
    }

    this._upscopeApiKey = ''
    this._bSockeDisconnected = false
    this.featureToggles = {}
    const config = app.getConfig()
    if (config && config.upscope) {
      this._upscopeApiKey = config.upscope.api_key
    }

    this._references = {
      page: React.createRef()
    }
  }

  componentDidMount () {
    app.setPageContainer(this)

    if (app.request.pageIdent === 'sitelogout') {
      app.logout()
    }

    this.featureToggles = app.getFeatureToggles()
    this._initUpscope()
    this._initSocketConnectionEvents()
  }

  componentWillUnmount () {
    window.onbeforeunload = null
    app.setPageContainer(null)
    this._releaseSocketConnectionEvents()
  }

  render () {
    const messages = intlUtil.loadMessages()
    if (app.isDevModeEnabled()) {
      for (const key in messages) {
        messages[key] = key
      }
    }

    return (
      <IntlProvider
        locale={intlUtil.getIntlProviderLanguage()}
        messages={messages}
      >
        <div className='page-container'>
          <IntlFormat onAfterLoad={this._onAfterLoadIntl.bind(this)} />
          {this.state.bIntlReady && this._renderContent()}
        </div>
      </IntlProvider>
    )
  }

  _renderConnectionOverlay () {
    if (!this._bSockeDisconnected) {
      return null
    }

    return (
      <div className='overlay-connection'>
        <div className='content-message'>
          <h2 className='message'>
            <span>
              {intlUtil.convertMessage(
                'common.list.connectionLostMessageError'
              )}
            </span>
          </h2>
          <div className='splitter' />
          <div className='info'>
            {intlUtil.convertMessage('common.list.connectionLostMessageInfo')}
          </div>
        </div>
      </div>
    )
  }

  _initSocketConnectionEvents () {
    ConnectionUtil.initSocketConnectionEvents(this._onReconnect.bind(this))
  }

  _releaseSocketConnectionEvents () {
    ConnectionUtil.releaseSocketConnectionEvents()
  }

  reloadPage () {
    FabButtonManager.clearEventListener()

    this.setState({ dataDate: new Date() })
  }

  /* Init socket connection events */
  _onReconnect (bConnected, _bShowMessage) {
    if (bConnected) {
      app.authentication.refresh(payload => {
        if (payload) {
          this._bSockeDisconnected = false
          this.refresh()
        } else {
          window.location.reload()
        }
      })
    } else {
      this._bSockeDisconnected = true

      this.setState({ dataDate: new Date() })
    }
  }

  refresh () {
    this.forceUpdate()
  }

  _renderContent () {
    return (
      <div className='pagecontainercont'>
        {this._renderConnectionOverlay()}
        {this._renderPage()}
      </div>
    )
  }

  _renderPage () {
    const pageIdent = app.request.pageIdent
    const param1 = app.request.param1
    const param2 = app.request.param2
    const param3 = app.request.param3

    // Common
    if (pageIdent === 'login') {
      return <PageLoginV2 showForgot={false} />
    } else if (pageIdent === 'team-select') {
      return <PageTeamSelect />
    } else if (pageIdent === 'forgot-password') {
      return <PageLoginV2 showForgot />
    } else if (pageIdent === 'signup') {
      return <PageSignup token={param1} />
    } else if (pageIdent === 'reset') {
      return <PageResetv2 token={param1} />
    } else if (pageIdent === 'user-profile') {
      return <PageUserProfile />
    } else if (pageIdent === 'user-schedule') {
      return <PageSchedule />
    } else if (pageIdent === 'user-absent') {
      return <PageAbsent ref={this._references.page} />
    } else if (pageIdent === 'user-skills') {
      return <PageSkills />
    } else if (pageIdent === 'personal-setting') {
      return <PagePersonalSetting />
    } else if (pageIdent === 'signupteam') {
      return <PageSignupTeamV2 country={param1} email={param2} />
    } else if (pageIdent === '404Error') {
      return <Page404 />
    } else if (pageIdent === 'blocked') {
      return <PageBlock />
    } else if (pageIdent === 'signupconfirm') {
      return <PageSignupConfirm token={param1} />
    } else if (pageIdent === 'demo-register') {
      return <PageDashboard ref={this._references.page} showDemoRegister />

      // Contact
    } else if (pageIdent === 'contact') {
      return app.redirect('/contacts')
    } else if (pageIdent === 'contact-add') {
      return app.redirect('/contacts')
    } else if (pageIdent === 'contact-edit') {
      return app.redirect('/contacts')
    } else if (pageIdent === 'contact-view') {
      return app.redirect(`/contacts/${param1}`)

      // Report
    } else if (pageIdent === 'report') {
      return <PageReport />
    } else if (pageIdent === 'report-view') {
      return <PageReportView reportIdent={param1} filterObj={param2} />

      // Project
    } else if (pageIdent === 'project') {
      return (
        <PageProject
          ref={this._references.page}
          showadd={param1 === 'showadd'}
        />
      )
    } else if (pageIdent === 'projectview-team') {
      return (
        <PageProjectViewTeam ref={this._references.page} projectId={param1} />
      )
    } else if (pageIdent === 'projectview-budget') {
      return (
        <PageProjectViewBudget
          ref={this._references.page}
          projectId={param1}
          showedit={param2 === 'showedit'}
        />
      )
    } else if (pageIdent === 'projectview-budgetv2') {
      return (
        <PageProjectViewBudgetV2
          ref={this._references.page}
          projectId={param1}
          showedit={param2 === 'showedit'}
        />
      )
    } else if (pageIdent === 'projectview-hour') {
      return <PageProjectViewHour projectId={param1} />
    } else if (pageIdent === 'projectview-overview') {
      return (
        <PageProjectViewOverview
          ref={this._references.page}
          projectId={param1}
        />
      )
    } else if (pageIdent === 'projectview-planner') {
      return <PageProjectViewPlanner projectId={param1} />
    } else if (pageIdent === 'projectview-task') {
      return (
        <PageProjectViewTask ref={this._references.page} projectId={param1} />
      )
    } else if (this.featureToggles.FEATURE_USE_STREAM === 'true' && pageIdent === 'chat') {
      return <PageChat />
      // Setting
    } else if (pageIdent === 'setting-user') {
      return (
        <PageUser ref={this._references.page} showadd={param1 === 'showadd'} />
      )
    } else if (pageIdent === 'setting-companyprofile') {
      return <PageCompanyProfile />
    } else if (pageIdent === 'setting-project') {
      return <PageProjectSetting />
    } else if (pageIdent === 'setting-demodata') {
      return <PageDemoSetting />
    } else if (pageIdent === 'setting-integration') {
      return <PageIntegration />
    } else if (pageIdent === 'setting-payment') {
      return <PagePayment />
    } else if (pageIdent === 'setting-subscription') {
      return <PageSubscription messageType={param1} />
    } else if (pageIdent === 'setting-paymentfailed') {
      return <PagePaymentFailed invoiceId={param1} />
    } else if (pageIdent === 'setting-pdftemplate') {
      return <PagePdfTemplate />
    } else if (pageIdent === 'setting-mailtemplate') {
      return <PageMailTemplate />
    } else if (pageIdent === 'setting-taxrate') {
      if (app.teamCountry === 'US' && !app.isQuickbookConnected()) {
        return <PageTaxRate />
      } else {
        return <Page404 />
      }

      // Time
    } else if (pageIdent === 'time') {
      let timeShowAdd = false
      let timeWeekNo = null
      let activeTimeCardId = null
      let activeTimeUserId = null
      let activeTimeDate = null

      if (param1 === 'addTimeCard') {
        timeShowAdd = true
      } else if (param1 === 'showWeek') {
        timeWeekNo = param2
      } else if (param1 === 'showTimeCard') {
        activeTimeCardId = param2
        activeTimeUserId = param3.userId
        activeTimeDate = param3.date
      }

      return (
        <PageTime
          ref={this._references.page}
          showAdd={timeShowAdd}
          weekNo={timeWeekNo}
          activeTimeCardId={activeTimeCardId}
          activeUserId={activeTimeUserId}
          activeTimeDate={activeTimeDate}
        />
      )
    } else if (pageIdent === 'time-mobile') {
      return <PageMobile ref={this._references.page} />

      // Planner
    } else if (pageIdent === 'planner') {
      return <PagePlanner />
    } else if (pageIdent === 'plannertask') {
      return <PagePlannerTask />

      // Estimate
    } else if (pageIdent === 'estimate') {
      return <PageEstimate ref={this._references.page} />
    } else if (pageIdent === 'estimate-view') {
      return (
        <PageEstimateView ref={this._references.page} estimateId={param1} />
      )

      // Expense
    } else if (pageIdent === 'expenses') {
      return <PageExpense ref={this._references.page} />
    } else if (pageIdent === 'purchaseorders') {
      return <PagePurchaseOrder ref={this._references.page} />
    } else if (pageIdent === 'purchaseorder-view') {
      return <PagePurchaseOrderView purchaseOrderId={param1} />

      // Invoice
    } else if (pageIdent === 'invoices') {
      return <PageInvoice ref={this._references.page} />
    } else if (pageIdent === 'invoice-view' && param1) {
      return <PageInvoiceView key={param1} invoiceId={param1} />
    } else if (pageIdent === 'invoice-template') {
      return <PageInvoiceTemplate />
    } else if (pageIdent === 'invoice-template-view' && param1) {
      return <PageInvoiceTemplateView invoiceTemplateId={param1} />

      // Task
    } else if (pageIdent === 'task') {
      let showAddTask = false
      let project = null
      const date = param2 && param2.date ? param2.date : null
      if (param3 === 'addTask') {
        showAddTask = true
        project = param2 && param2.project ? param2.project : null
      }

      return Acl.isStandardUser() ? (
        <PageTaskStandardUser
          ref={this._references.page}
          editTaskId={param1}
          date={date}
          showAddTask={showAddTask}
          project={project}
        />
      ) : (
        <PageTaskMain
          ref={this._references.page}
          editTaskId={param1}
          date={date}
          showAddTask={showAddTask}
          project={project}
        />
      )
    } else if (pageIdent === 'sitechangeteam') {
      return <PageDashboard ref={this._references.page} showChangeTeam />
    } else if (pageIdent === 'sitemyaccount') {
      return <PageDashboard ref={this._references.page} />
    } else if (pageIdent === 'emailconfirm') {
      return <PageEmailConfimation />
    } else if (pageIdent === 'tokenexpired') {
      return <PageExpired />
    } else if (pageIdent === 'demoimport') {
      return <PageDemoImport />
    }

    return <PageDashboard ref={this._references.page} />
  }

  _onAfterLoadIntl () {
    this.setState({ bIntlReady: true })
  }

  _initUpscope () {
    const team = app.getTeam()
    const userTeam = app.user

    if (team && userTeam) {
      const upscopeSettings = {
        apiKey: this._upscopeApiKey,
        identities: [team.name, userTeam.email],
        uniqueId: userTeam.id
      }

      if (window.Upscope) {
        window.Upscope('init', upscopeSettings)
      }
    }
  }
}

export default PageContainer
